import React from 'react';
import { Box, Typography } from '@mui/material';
import { vortxTypography } from '@vortx/shared-ui';
import { alpha } from '@mui/material/styles';
import { COLORS } from '../results/ResultsDesignTokens';

export default function CriterionCard({ name, threshold, actual, passed, priority }) {
    const isMustHave = priority === 'must-have';
    const color = passed ? COLORS.efficiency : COLORS.loss;

    return (
        <Box sx={{
            p: 2,
            bgcolor: COLORS.bg.card,
            border: `1px solid ${alpha(color, 0.3)}`,
            borderRadius: 2,
            borderLeft: `3px solid ${color}`,
            position: 'relative',
        }}>
            {/* Priority tag */}
            <Box sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                px: 0.75,
                py: 0.25,
                bgcolor: alpha(isMustHave ? COLORS.loss : COLORS.solar, 0.1),
                border: `1px solid ${alpha(isMustHave ? COLORS.loss : COLORS.solar, 0.3)}`,
                borderRadius: 0.5,
            }}>
                <Typography sx={{
                    fontFamily: vortxTypography.mono,
                    fontSize: '0.5rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    color: isMustHave ? COLORS.loss : COLORS.solar,
                }}>
                    {priority}
                </Typography>
            </Box>

            {/* Name */}
            <Typography sx={{
                fontFamily: vortxTypography.mono,
                fontSize: '0.75rem',
                fontWeight: 600,
                color: COLORS.text.primary,
                mb: 1,
                pr: 8,
            }}>
                {name}
            </Typography>

            {/* Threshold vs Actual */}
            <Box sx={{ display: 'flex', gap: 3, alignItems: 'baseline' }}>
                <Box>
                    <Typography sx={{
                        fontFamily: vortxTypography.mono,
                        fontSize: '0.6rem',
                        color: COLORS.text.muted,
                        textTransform: 'uppercase',
                    }}>
                        Target
                    </Typography>
                    <Typography sx={{
                        fontFamily: vortxTypography.heading,
                        fontSize: '1.1rem',
                        fontWeight: 700,
                        color: COLORS.text.secondary,
                    }}>
                        {threshold}
                    </Typography>
                </Box>
                <Box>
                    <Typography sx={{
                        fontFamily: vortxTypography.mono,
                        fontSize: '0.6rem',
                        color: COLORS.text.muted,
                        textTransform: 'uppercase',
                    }}>
                        Actual
                    </Typography>
                    <Typography sx={{
                        fontFamily: vortxTypography.heading,
                        fontSize: '1.1rem',
                        fontWeight: 700,
                        color: color,
                        textShadow: `0 0 8px ${alpha(color, 0.4)}`,
                    }}>
                        {actual}
                    </Typography>
                </Box>
                <Box sx={{
                    ml: 'auto',
                    px: 1.5,
                    py: 0.5,
                    bgcolor: alpha(color, 0.1),
                    border: `1px solid ${alpha(color, 0.3)}`,
                    borderRadius: 1,
                }}>
                    <Typography sx={{
                        fontFamily: vortxTypography.mono,
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        color: color,
                    }}>
                        {passed ? 'PASS' : 'FAIL'}
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
}
